<template>

    <div class="language-box" :class="$mq" @click="changeLanguage">

        {{ switchToLanguage }}

    </div>
  
</template>

<script>
import { EventBus } from '../events/eventbus.js';

export default {
    data: () => { return {
        switchToLanguage: 'ENGLISH',
        }
    },
    methods: {
        changeLanguage() {
            if (this.switchToLanguage === 'ENGLISH') {
                this.switchToLanguage = 'DUTCH'
                EventBus.$emit('language', 'ENGLISH');
            } else {
                this.switchToLanguage = 'ENGLISH'
                EventBus.$emit('language', 'DUTCH');  
            }
    }
  }
}
</script>

<style lang="scss">

.language-box  {
    padding: .5rem;
    border: 2px solid currentColor;


    cursor: pointer;

    font-size: 1.8rem;   


    @media only screen and (max-width: 700px) {
        font-size: 1.4rem;
        padding: .4rem;
    }

}

</style>